export const stripeSubscription = {
	title: "Gérer votre abonnement",
	active: "Actif",
	expired: "Expiré",
	'cancel-subscription': {
		title: "Cliquez ici pour résilier votre abonnement",
		label: "Résilier mon abonnement",
		failed: "La résiliation de votre abonnement n’a pas pu être effectuée. Merci de réessayer un peu plus tard.",
		success: "Votre abonnement a bien été résilié. Un email de confirmation vous a été envoyé.",
		alert: "{0} Vous avez demandé la résiliation de votre abonnement le {1}. Votre demande a bien été prise en compte votre abonnement sera résilié à sa date anniversaire."


	},
	popin: {
		title: "Résiliation de mon abonnement",
		action: {
			label: "confirmer la résiliation",
			title: "Résiliation de mon abonnement"
		},
		cancel: {
			label: "annuler"
		}
	},
	'annual-subscription': "Abonnement annuel",
	'monthly-subscription': "Abonnement mensuel",
	'license-expired-on': "Abonnement expirée depuis le {0}",
	'license-valid-until': "Abonnement valide jusqu’au {0}",
	'no-license': {
		text1: "{0} Votre compte ne dispose d’aucun abonnement actif. Abonnez-vous dès maintenant pour accéder à l’ensemble des fonctionnalités en cliquant {1}.",
		text2: "ici",
		title: "Cliquez ici pour vous abonner"
	},
	demo: {
		text: "{0} Ceci est une version de démo, aucun abonnement n’est requis ici 😉"
	}
}
